import * as React from 'react';
import { Box } from '@mui/material';
import RadioButtons from './RadioButtons';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';
import Line from '../../../../shared/components/line/index';
import { BMICard } from '../../../../shared/components/bmiCard/index';
import { henryOxfordSelection } from '../../../../shared/shared.constants';
import LightBlueCard from '../../../../shared/components/lightBlueCard/index';
import BmiIcon from '../../../../assets/icons/Icon_Improve Treatment_Large_White.svg';
import { SingleNumberCard } from '../../../../shared/components/numberInput/numberCards/singleNumberCard';
import { useEffect } from 'react';

export const Tab1 = ({
  BMRVal,
  activityFactor,
  setActivityFactor
}: {
  BMRVal: number;
  activityFactor: {
    optionSelected: string;
    value: number;
    bmrPlusActivityFactor: number;
  };
  setActivityFactor: (val: {
    optionSelected: string;
    value: number;
    bmrPlusActivityFactor: number;
  }) => UnknownAction;
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setActivityFactor({
        ...activityFactor,
        bmrPlusActivityFactor: Number(
          ((BMRVal * activityFactor.value) / 100 + BMRVal).toFixed(2)
        )
      })
    );
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        borderRadius: '0.9375rem',
        gap: '1.875rem',
        marginTop: '1.875rem',
        padding: '0 0.9375rem',
        marginBottom: '1.875rem'
      }}
    >
      <RadioButtons
        BMRVal={BMRVal}
        activityFactor={activityFactor}
        setActivityFactor={setActivityFactor}
      />
      <Line color="#D9D9D6" height="0.0625rem" width="100%" />
      <Box
        sx={{
          border: '0.0625rem solid #D9D9D6',
          borderRadius: '0.9375rem',
          width: '100%',
          textAlign: 'center'
        }}
      >
        <SingleNumberCard
          width={'100%'}
          title={'ACTIVITY FACTOR'}
          marginVal={'0.625rem'}
          range={{
            min: activityFactor.optionSelected
              ? henryOxfordSelection.activityFactor[
                  `${activityFactor.optionSelected}`
                ].min
              : 0,
            max: activityFactor.optionSelected
              ? henryOxfordSelection.activityFactor[
                  `${activityFactor.optionSelected}`
                ].max
              : 0
          }}
          subHead={'(%)'}
          value={activityFactor.value}
          setValue={(val: number) => {
            dispatch(
              setActivityFactor({
                ...activityFactor,
                value: val,
                bmrPlusActivityFactor: Number(
                  ((BMRVal * val) / 100 + BMRVal).toFixed(2)
                )
              })
            );
          }}
        />
      </Box>
      <Line color="#D9D9D6" height="0.0625rem" width="100%" />
      <LightBlueCard
        label={'Activity factor (kcal):'}
        value={`+ ${Number(((activityFactor.value * BMRVal) / 100).toFixed(2))}`}
      />
      <BMICard
        label1={'BMR + ACTIVITY FACTOR'}
        label2={`${activityFactor.bmrPlusActivityFactor} kcal`}
        icon={BmiIcon}
      />
    </Box>
  );
};
